import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { INegotiateInfluencerCost } from "@shared/lib/types/briefInfluencerV2";
import { BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY } from "../constants";
import { BriefService } from "../services/brief.service";

export function useNegotiateInfluencerCost(briefId: string) {
  const {
    mutate: negotiateInfluencerCost,
    isLoading: isNegotiatingInfluencerCost,
    isSuccess: isNegotiatedInfluencerCost,
  } = useMutation({
    mutationFn: (data: INegotiateInfluencerCost) =>
      BriefService.negotiateInfluencerCost(data).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    options: {},
    onSuccess: (c) => {
      c.invalidateQueries({
        queryKey: [...BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY],
      });

      c.invalidateQueries({
        queryKey: [...BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY, "facets", briefId],
      });
    },
  });

  return {
    negotiateInfluencerCost,
    isNegotiatingInfluencerCost,
    isNegotiatedInfluencerCost,
  };
}
